<template>
    <advertiser-selector
        @selection="redirectToAdvertiser"
    ></advertiser-selector>
</template>

<script>
import store from './store.js'
import { mapActions, mapGetters } from 'vuex';

export default {
  store: store,

  data(){
    return {
        baseUrl: window.Portal.baseUrl,
    }
  },

  methods: {
    ...mapActions([
      'fetchAdvertiser',
      'fetchAdvertisers',
      'fetchLocations',
      'fetchSessionAdvertiser',
      'impersonateAdvertiser'
    ]),

    redirectToAdvertiser(advertiser) {
      if (typeof this.advertiser == 'undefined') {
            return;
      }

      // If either advertiser or checkbox has changed then re-run impersonate
      if (this.advertiser.id !== advertiser.id) {
        this.impersonateAdvertiser({
            id: advertiser.id,
            baseUrl: this.baseUrl,
            callback: (response) => {
                window.location.reload(true);
          }
        });
      }
    },

    selectAdvertiser(selectedAdvertiser){
        if(this.advertiser.id !== selectedAdvertiser.id) {
            this.fetchAdvertiser({baseUrl: this.baseUrl, id: selectedAdvertiser.id});
        }
    }
  },

  computed: {
    ...mapGetters([
      'advertiser',
      'advertisers',
      'locations',
      'loadingAdvertiser',
      'loadingAdvertisers',
      'loadingLocations'
    ])
  },

  mounted: function () {
    this.fetchSessionAdvertiser({
      baseUrl: this.baseUrl
    })
    this.fetchAdvertisers({
      baseUrl: this.baseUrl
    })
    this.fetchLocations({
      baseUrl: this.baseUrl
    })
  }
}
</script>
